import { render, staticRenderFns } from "./ReporteExcedentes.vue?vue&type=template&id=6b143812"
import script from "./ReporteExcedentes.vue?vue&type=script&lang=js"
export * from "./ReporteExcedentes.vue?vue&type=script&lang=js"
import style0 from "./ReporteExcedentes.vue?vue&type=style&index=0&id=6b143812&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports